export class BenutzerSignatur {
    benutzer_id: number;
    unterschrift_png: string;
}
